import type { ReactNode } from 'react';

export const symbol_table_lamp: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M550-120q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h260q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H550ZM191-580h189v-200H278l-87 200Zm467.5 351.37Q650-237.25 650-250v-390q0-21.25-14.37-35.63Q621.25-690 600-690H440v140q0 12.75-8.62 21.37Q422.75-520 410-520H145q-16.74 0-25.87-13.5Q110-547 117-562l106-242q8-17 22.55-26.5T278-840h102q24.75 0 42.38 17.62Q440-804.75 440-780v30h160q45.83 0 77.92 32.08Q710-685.83 710-640v390q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63ZM191-580h189-189Z"
		/>
	</svg>
);
